import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Grid,
  Typography, 
  TextField,
  TableContainer,
} from "@mui/material";
import { Box } from "@mui/system";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export default function Packages() {
  const [user, setUser] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [checked, setChecked] = useState(false);
  const [date, setDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [jobs, setJobs] = useState([]);

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleChange1 = (event) => {
    setSelectedOption(event.target.value);
  };

  const data = [
    {
      id: 1,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Active",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 2,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Expired",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 3,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Expired",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 4,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Active",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 5,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Renew",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 6,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Active",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 7,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Renew",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 8,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Expired",
      header5: "20/04/24",
      header6: "5000",
    },
    {
      id: 9,
      header1: "Base",
      header2: "12/04/23",
      header3: "#987654352617",
      header4: "Active",
      header5: "20/04/24",
      header6: "5000",
    },

    // Add more data objects as needed
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const navigate = useNavigate();
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleChange = () => {
    setSelectedOption(!checked);
  };

  return (
    <>
      <Layout>
        <UserLayout userRole={"coach"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              my: 8,
              borderRadius: "10px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", width: "100%" }}>
              Packages
            </Typography>
            <TextField
              sx={{
                background: "#3665D014",
                width: "70%",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
              }} // Updated style
              variant="outlined"
              size="small"
              placeholder="Search"
              onChange={handleSearch}
              InputProps={{
                endAdornment: <SearchIcon sx={{ opacity: "0.5" }} />,
              }}
            />
          </Box>

          <Paper sx={{ px: 5, py: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                verticalAlign: "middle",
                alignItems: "center",
                height: "2.5rem",
                my: 2,
              }}
            >
              <select
                style={{
                  marginLeft: "1rem",
                  backgroundColor: "#D9E3F6",
                  maxWidth: "200px",
                }}
                className="profile-skills-box text2Light"
                value={selectedOption}
                onChange={handleChange}
              >
                <option disabled value="">
                  Sort by date
                </option>
                <option value="option1">Option 1</option>
                <option value="option2">Option 2</option>
                <option value="option3">Option 3</option>
              </select>

             
            </Box>

            <Paper>
              <Grid container>
                <Grid item xs={12}>
                  <TableContainer sx={{ width: "100%", overflowX: "auto" }}>
                    <Table width="auto">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Package Name
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Transaction ID
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Status
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Expired
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Amount ₹
                          </TableCell>
                          <TableCell
                            className="text2Bold"
                            style={{
                              width: "fit-content",
                              textAlign: "center",
                            }}
                          >
                            Invoice
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((row) => (
                          <TableRow key={row?.id}>
                            <TableCell
                              className="text2Mid"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <p
                                className="text2Mid"
                                style={{ color: "#2544EE", margin: "0px" }}
                              >
                                {row?.header1}
                              </p>
                              <p className="text3Mid" style={{ margin: "0px" }}>
                                {row?.header2}
                              </p>
                            </TableCell>
                            <TableCell
                              className="text2Bold"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              {row?.header3}
                            </TableCell>
                            <TableCell
                              className="text2Mid"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  color:
                                    row.header4 === "Active"
                                      ? "#41B249"
                                      : row.header4 === "Expired"
                                      ? "#FF0000"
                                      : row.header4 === "Renew"
                                      ? "#F8BB54"
                                      : "",
                                  px: 2,
                                  py: 1,
                                  fontWeight: "bold",
                                }}
                              >
                                {row?.header4}
                              </Box>
                            </TableCell>
                            <TableCell
                              className="text2Bold"
                              style={{
                                width: "fit-content",
                                textAlign: "center",

                                fontWeight: "bold",
                              }}
                            >
                              {row?.header5}
                            </TableCell>
                            <TableCell
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <Button
                                className="text2Mid"
                                onClick={() => navigate("/employer/job-view")}
                              >
                                {row?.header6}
                              </Button>
                            </TableCell>
                            <TableCell
                              className="text2Mid"
                              style={{
                                width: "fit-content",
                                textAlign: "center",
                              }}
                            >
                              <IconButton sx={{color:'#2544EE'}}>
                                <CloudDownloadIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}

                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Paper>
        </UserLayout>
      </Layout>
    </>
  );
}
